<template>
	<a-drawer title="查看信息" :visible="showFlag"  width="560" @close="closeView()" :destroyOnClose='true' :maskClosable="true">
		<vxe-table  align="center" :data="list"  border max-height="600"   ref="mTable"
						  resizable highlight-hover-row :loading="loading" size="mini">
			<vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
			<vxe-table-column title="设备地址" field="device_addr"  width="140"></vxe-table-column>
			<vxe-table-column title="信号质量" field="csq" ></vxe-table-column>
			<vxe-table-column title="电压" field="voltage"></vxe-table-column>
			<vxe-table-column title="创建时间" field="create_time"  width="160" :formatter="getTimeFormatter"></vxe-table-column>
		</vxe-table>
	</a-drawer>
</template>

<script>
	export default {
		data() {
			return {
				showFlag:false,
				loading:false,
				deviceAddr:null,
				list:[],
			}
		},
		methods: {
			closeView(){
				this.deviceAddr = null;
				this.showFlag = false;
			},
			showView(item){
				this.deviceAddr = item.deviceAddress;
				this.queryInfoData();
				this.showFlag = true;
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			queryInfoData(){
				let param = {
					deviceAddr:this.deviceAddr
				};
				let url = this.Api.getLastUrl(this.Api.DY_4G_QUERY_INFO_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
	}
</script>

<style>
</style>
